import * as React from "react";

import { cn } from "@beweegbaas/ui/lib/utils";

/**
 * `Button`s joined into one control, such as back, today and forward. The buttons keep their own
 * variant and hover; the group only joins their edges (the `group-button` styles in button.tsx).
 */
function ButtonGroup({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      role="group"
      data-slot="button-group"
      className={cn(
        "group group-button flex *:not-first:border-l-0 *:focus-visible:z-10",
        className,
      )}
      {...props}
    />
  );
}

export { ButtonGroup };
